export const environment = {
  production: false,
  // learningUrl: 'https://learning-dev.tsin.ca/',
  learningUrl: 'https://d2unppq4hwq1m9.cloudfront.net/',
  // userBaseUrl: 'https://user-dev-be.tsin.ca/api',
  userBaseUrl: 'https://zxkbbj3pcy.us-east-1.awsapprunner.com/api',
  userMgtUrl: 'https://d2xhgoo376k0s0.cloudfront.net/login/exam',
  // userMgtUrl: 'https://user-dev.tsin.ca/auth/login',
  // userMgtUrl: 'https://d2xhgoo376k0s0.cloudfront.net/',
  examUrl: 'https://d6ioof9j273ua.cloudfront.net/',
  examOldUrl: 'https://d6ioof9j273ua.cloudfront.net/',
  paymentUrl: 'https://payment-dev.tsin.ca',
  apiUrl: 'https://pikx4ijcua.us-east-1.awsapprunner.com/api',
  learningBaseUrl: 'https://learning-dev-be.tsin.ca/api',
  examOldBaseUrl: 'https://portalstage-be.tsin.ca/api',
  userBaseUrlFallback: 'http://user-dev-be.tsin.ca/api',
  userBaseMgtUrlFallback: 'http://user-dev.tsin.ca/auth/login',
  salt: 'ZC\f?.Kp[jnhXf3-"<f3{/tZS@#~(8on',
  paymentMode: 'qa',
  paymentTimeLimitInMs: 180000,
};
